import styled from 'styled-components';

export const StyledComponent = styled.div`
  display: flex;
  flex-flow: row nowrap;
  overflow: hidden;
  height: 40px;
  flex: 1 1 100%;
  align-self: center;
  background-color: #fafbfc;
  border: 1px solid #f4f5f7;
  border-radius: 5px;
  margin: 0px;
  user-select: none;

  &:hover,
  &:focus {
    outline: none;
    border-color: #4c9aff;
    border-width: 2px;
    background-color: #fff;
    margin: -1px;
  }
`;

export const FilterIcon = styled.img`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  padding: 0px 15px;
  border-right: 1px solid #f4f5f7;
  background-color: #f2f2f2;
  width: 14px;
`;

export const InputList = styled.div`
  cursor: text;
  display: flex;
  flex-flow: row wrap;
  min-width: 100%;
  align-items: center;
`;

export const InputListItem = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  margin: 1px 2px 0px 2px;
  font-size: 11px;
  padding: 0px 3px;
  height: 19px;
  line-height: 19px;
  border-radius: 2px;
  background: ${props => (props.isDefault ? '#ebebeb' : 'rgba(9, 30, 66, .04)')};
  border-color: ${props => (props.isDefault ? '#7A869A' : '')};
  color: ${props => (props.isDefault ? 'rgba(0, 0, 0, .5)' : 'rgba(0, 0, 0, .9)')};
  white-space: nowrap;
  border: 1px solid #7A869A;

  span {
    color: #172B4D;
    line-height: 18px;
    height: 100%;
    margin-left: 3px;
    padding-left: 3px;
    cursor: pointer;
    border-left: 1px solid #7A869A;
  }

  &:hover span {
    color: #050a12;
  }
`;

export const ItemTitle = styled.b`
  margin-right: 3px;
  padding-right: 3px;
  border-right: 1px solid #7A869A;
`;
